import FieldsCollection from "../../../fields3/collection/base/fields-collection";
import {EntityType} from "../../../gd/const/item";
import FieldConfig from "../../../fields3/proto/field-config";
import {FieldType} from "../../../fields3/field-type";
import FieldString from "../../../fields3/generic/string/string";
import {ExpenseSystemType} from "../@types";
import FieldDropdown from "../../../fields3/generic/dropdown/dropdown";
import FieldExpenseApprovalStatus from "../../../fields3/system/expense/approval-status/approval-status";
import FieldExpenseReimbursement from "../../../fields3/system/expense/reimbursement/reimbursement";
import FieldCurrency from "../../../fields3/generic/finance/currency/currency";

export default class ExpenseCategoryFields extends FieldsCollection {

    // not in use at the moment

    constructor(options:any = {}) {

        // it should be inside constructor because it's using moment()
        const baseConfig : FieldConfig[] = [
            {
                fieldId             : 'name',
                label               : 'Expense name',
                type                : FieldType.STRING,
            },
            {
                fieldId     : 'systemType',
                type        : FieldType.DROPDOWN,

                // isDisabled  : !!this.expenseCategory.id, // id means we edit not add
                options     : [
                    {label: 'Amount based', value: ExpenseSystemType.AMOUNT},
                    {label: 'Unit based', value: ExpenseSystemType.UNIT},
                ],
                showMenuMore    : false,
                noValueOption   : false,
            },


            {
                fieldId         : 'unitPrice',
                type            : FieldType.CURRENCY,

            },
            {
                fieldId         : 'unitName',
                type            : FieldType.STRING,
                label           : 'Unit name'
            },

            {
                fieldId         : 'approvalStatus',
                label           : 'Approval status',
                type            : FieldType.EXPENSE_APPROVAL_STATUS,
                defaultWidth    : 180,
            },
            {
                fieldId         : 'reimbursement',
                label           : 'Reimbursement',
                type            : FieldType.EXPENSE_REIMBURSEMENT
            },
        ]

        super(baseConfig, EntityType.EXPENSE_CATEGORY)

    }

    // Quick access

    get name()                  { return this.get('name') as FieldString }
    get systemType()            { return this.get('systemType') as FieldDropdown }
    get approvalStatus()        { return this.get('approvalStatus') as FieldExpenseApprovalStatus }
    get reimbursement()         { return this.get('reimbursement') as FieldExpenseReimbursement }
    get unitPrice()             { return this.get('unitPrice') as FieldCurrency }
    get unitName()              { return this.get('unitName') as FieldString }



}
